import { Button, Loading } from '@carbon/react';
import { FormattedCount } from 'components/formatted-count';
import type { ActivityFeed } from './hooks';
import style from './activity-log-footer.module.scss';

interface ActivityLogFooterProps {
  activity: ActivityFeed;
}

/**
 * The end of an activity log: the next page's loader, its progress, or its failure.
 *
 * @param {ActivityLogFooterProps} props - The activity feed.
 * @return {JSX.Element | null} The footer, or nothing once the whole feed is loaded.
 */
export function ActivityLogFooter({ activity }: ActivityLogFooterProps) {
  if (activity.loadingMore) {
    return (
      <div className={style.footer}>
        <Loading small withOverlay={false} description="Loading activity" />
      </div>
    );
  }
  if (activity.loadMoreFailed) {
    return (
      <p className={style.footer}>
        Couldn’t load more activity.{' '}
        <Button kind="ghost" size="sm" onClick={activity.loadMore}>
          Retry
        </Button>
      </p>
    );
  }
  if (activity.nextPageCount === 0) return null;
  return (
    <div className={style.footer}>
      <Button kind="ghost" size="sm" onClick={activity.loadMore}>
        Load <FormattedCount value={activity.nextPageCount} /> more
      </Button>
    </div>
  );
}
